import Cookies from "js-cookie";
import CryptoJS from "crypto-js";
import config from "../config";
import { getSessionForLoginUser } from "$lib/utils/cookie";

const AUTH_KEY = `${config.CLIENT_ID}_auth`;
const ENCRYPTOR_KEY: string = config.CLIENT_SECRET as string;
// let token: any;

export const getCookie = (cookieName: string, str: any): any => {
    let cookies = Cookies.get(cookieName);
    if (cookies) {
        const bytes = CryptoJS.AES.decrypt(cookies!, ENCRYPTOR_KEY);
        const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return decryptedData[str];
    }
    return null;
};

export const getAuthToken = () => {
    // token = getCookie(AUTH_KEY, `${config.PROJECT_APP}_accessTokenUser`);
    return getCookie(AUTH_KEY, `${config.PROJECT_APP}_accessTokenUser`);
};

export const authToken = getCookie(
    AUTH_KEY,
    `${config.PROJECT_APP}_accessTokenUser`,
);
